import { FormAnswer, StepDirection } from 'scenes/common/types';

export const nextPage = <FormValues, StepType>(
  values: FormValues
): FormAnswer<FormValues, StepType> => ({
  direction: StepDirection.Next,
  formValues: values,
  apiResponses: {},
});

export const nextIfLocationIs = <FormValues, StepType>(
  stepFilter: StepType,
  formValues: FormValues
): FormAnswer<FormValues, StepType> => ({
  direction: StepDirection.Next,
  apiResponses: {},
  formValues,
  stepFilter,
});

export const restartQuote = <FormValues, StepType>(): FormAnswer<
  FormValues,
  StepType
> => ({
  direction: StepDirection.Beginning,
  apiResponses: {},
  formValues: {} as FormValues,
});

export const previousPage = <FormValues, StepType>(): FormAnswer<
  FormValues,
  StepType
> => ({
  direction: StepDirection.Previous,
  formValues: {} as FormValues,
  apiResponses: {},
});
